var map = {
	"./commitmate.png": 524,
	"./copium.png": 257,
	"./finassist.png": 464,
	"./profile.jpg": 277,
	"./prompt-tester.png": 624,
	"./sift.png": 862,
	"./votosecure.png": 173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;